import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-031dbbda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn-toolbar mb-3" }
const _hoisted_2 = { class: "input-group" }

import { PropType, computed, ref, onMounted, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';
import { CommunicationViewModel, EmailAddressViewModel } from '@/model/ViewModel';
import MessageHeaders from '@/components/MessageHeaders.vue';
import axios from 'axios';



export default /*#__PURE__*/_defineComponent({
  __name: 'EmailPreview',
  props: {
    message: {
        type: Object as PropType<CommunicationViewModel>,
        required: true
    }
},
  setup(__props) {

const props = __props

const { t } = useI18n();



const bodyIFrame = ref<HTMLIFrameElement | undefined>();

const clickUrl = ref('');


onMounted(() =>
{
    watchEffect(() => 
    {
        if (!props.message || !bodyIFrame.value)
            return;

        const document = bodyIFrame.value.contentWindow?.document;
        if (!document)
            return;

        document.open();
        document.write(props.message.Email!.Html);
        document.close();
    });
});


const headers = computed(() =>
{
    const result: any = {};

    result[t('header.sourceId')] = props.message.SourceID;
    result[t('header.from')] = addressToString(props.message.Email!.Sender);
    result[t('header.to', { count: props.message.Email!.Recipients })] = props.message.Email!.Recipients
        .map(r => addressToString(r))
        .join(", ");
    result[t('header.subject')] = props.message.Email!.Subject;

    return result;
});


function addressToString(address: EmailAddressViewModel)
{
    return `${address.Name} <${address.Email}>`;
}


async function triggerOpen()
{
    await axios.post('/v1/mailevent/open', {
        AutobedrijfID: props.message.AutobedrijfID,
        SourceID: props.message.SourceID
    });
}


async function triggerClick()
{
    if (!clickUrl.value)
        return;

    await axios.post('/v1/mailevent/click', {
        AutobedrijfID: props.message.AutobedrijfID,
        SourceID: props.message.SourceID,
        Url: clickUrl.value
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        onClick: triggerOpen,
        class: "btn btn-default"
      }, "Open"),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((clickUrl).value = $event)),
          type: "text",
          class: "form-control",
          placeholder: "URL..."
        }, null, 512), [
          [_vModelText, clickUrl.value]
        ]),
        _createElementVNode("button", {
          onClick: triggerClick,
          class: "btn btn-default"
        }, "Click")
      ])
    ]),
    _createVNode(MessageHeaders, { headers: _unref(headers) }, null, 8, ["headers"]),
    _createElementVNode("iframe", {
      class: "body",
      ref_key: "bodyIFrame",
      ref: bodyIFrame
    }, null, 512)
  ], 64))
}
}

})